import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { TechnicianService } from '../../../../../../services/technician.service';
import { Time } from '@angular/common';
import moment from 'moment';
import { OverlayPanel } from 'primeng/overlaypanel';

@Component({
  selector: 'app-edit-event',
  templateUrl: './edit-event.component.html',
  styleUrls: ['./edit-event.component.scss'],
})
export class EditEventComponent implements OnInit {
  @Input() event: any;
  @Input() index: any;
  @Input() technicianEvents: any;
  @Input() user: any;
  @Input() leaveEvent: any;
  @Input() eventPopup: OverlayPanel;
  @Output() refresh = new EventEmitter();

  public newEvent: boolean = true;
  public minDate: Date = new Date();
  public startTime: Date = new Date(0, 0, 0, 8, 0, 0);
  public endTime: Date = new Date(0, 0, 0, 9, 0, 0);
  public busy: boolean = false;

  constructor(private technicianService: TechnicianService) {}

  ngOnInit() {
    if (this.event && this.event.ID) {
      this.newEvent = false;
      this.event.StartTime = new Date(this.event.StartTime);
      this.event.EndTime = new Date(this.event.EndTime);
      this.startTime = this.event.StartTime;
      this.endTime = this.event.EndTime;
    } else {
      this.event = {
        Description: '',
        StartTime: new Date(),
        EndTime: new Date(),
        IsRecurringEvent: false,
        RecurIntervalDays: 0,
        RecurringCount: 0,
      };
    }
  }

  valid() {
    return (
      this.event.Description &&
      this.event.Description.length > 0 &&
      this.event.StartTime &&
      (this.event.IsRecurringEvent
        ? this.event.RecurIntervalDays > 0 && this.event.RecurringCount > 0
        : true)
    );
  }

  deleteEvent() {
    this.busy = true;
    this.technicianService
      .cancelCalendarEvent(
        this.user.TechnicianID ? this.user.TechnicianID : this.user.ID,
        this.event.ID,
        true,
      )
      .subscribe((result) => {
        this.refresh.emit();
        this.eventPopup.hide();
        this.busy = false;
      });
  }

  saveEvent() {
    let tzoffset = new Date().getTimezoneOffset() * 60000;
    this.event.StartTime = new Date(
      this.event.StartTime.getFullYear(),
      this.event.StartTime.getMonth(),
      this.event.StartTime.getDate(),
      this.startTime.getHours(),
      this.startTime.getMinutes(),
      0,
    );
    this.event.EndTime = new Date(
      this.event.StartTime.getFullYear(),
      this.event.StartTime.getMonth(),
      this.event.StartTime.getDate(),
      this.endTime.getHours(),
      this.endTime.getMinutes(),
      0,
    );

    if (!this.event.ID) {
      this.busy = true;
      this.technicianService
        .createCalendarEvent(
          this.user.TechnicianID ? this.user.TechnicianID : this.user.ID,
          this.event.Description,
          moment(this.event.StartTime - tzoffset).toISOString(false),
          moment(this.event.EndTime - tzoffset).toISOString(false),
          this.event.IsRecurringEvent,
          this.event.RecurringCount,
          this.event.RecurIntervalDays,
        )
        .subscribe((event) => {
          this.refresh.emit();
          this.eventPopup.hide();
          this.busy = false;
        });
    } else {
      if (this.technicianEvents) {
        this.technicianEvents.forEach((closeDates) => {
          const ID = parseInt(Object.keys(closeDates)[0]);
          this.technicianService
            .updateCalendarEventAll(
              closeDates[ID][this.index].ID,
              ID,
              this.event.Description,
              moment(
                closeDates[ID][this.index].StartTime - tzoffset,
              ).toISOString(false),
              moment(closeDates[ID][this.index].EndTime - tzoffset).toISOString(
                false,
              ),
              closeDates[ID][this.index].IsRecurringEvent,
              closeDates[ID][this.index].RecurringCount,
              closeDates[ID][this.index].RecurIntervalDays,
            )
            .subscribe((event) => {
              this.refresh.emit();
              this.eventPopup.hide();
              this.busy = false;
            });
        });
      } else {
        this.busy = true;
        this.technicianService
          .updateCalendarEvent(
            this.event.ID,
            this.user.TechnicianID ? this.user.TechnicianID : this.user.ID,
            this.event.Description,
            moment(this.event.StartTime - tzoffset).toISOString(false),
            moment(this.event.EndTime - tzoffset).toISOString(false),
            this.event.IsRecurringEvent,
            this.event.RecurringCount,
            this.event.RecurIntervalDays,
          )
          .subscribe((event) => {
            this.refresh.emit();
            this.eventPopup.hide();
            this.busy = false;
          });
      }
    }
  }
}
